import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerSW } from './services/pushClient';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Service worker registration (v85b). Async + fire-and-forget — failure
// here doesn't block the app, just means push won't work until next load.
registerSW().catch((e) => console.warn('[push] SW init failed:', e?.message));
